// Import JS Modules
import { createEmbellishmentStore } from './useStickerStore';

// --------------------------------------------------------------------

export const usePatternStore = createEmbellishmentStore('pattern');
